const errorCode = {
  '-8940004': '用户token过期,请重新登录',
  '-8940002': ''
}

export {
  errorCode
}


// WEBPACK FOOTER //
// ./src/config/index.js